import TenantsRoutes from "./TenantsRoutes/TenantsRoutes";
export { TenantsRoutes };
